var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',[_c('Navbar')],1),_c('v-img',{attrs:{"src":"https://media1.tenor.com/images/e3784e69e1d3114d42f6e5f51bea0879/tenor.gif?itemid=14949762"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }